/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_f7831252{background:blue}\n"}]);
export const dummy = "dummy_f7831252";